var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01172 18.6699C13.7687 18.6699 17.625 14.6405 17.625 9.66992C17.625 4.69936 13.7687 0.669922 9.01172 0.669922C4.25473 0.669922 0.398438 4.69936 0.398438 9.66992C0.398438 14.6405 4.25473 18.6699 9.01172 18.6699Z",
    fill: "#E88102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01758 17.7207C13.726 17.7207 17.543 13.9038 17.543 9.19531C17.543 4.48687 13.726 0.669922 9.01758 0.669922C4.30913 0.669922 0.492188 4.48687 0.492188 9.19531C0.492188 13.9038 4.30913 17.7207 9.01758 17.7207Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4039 1.37109L1.18203 12.5895C0.805859 11.7281 0.570313 10.793 0.5 9.81211L9.62305 0.685547C10.6039 0.759375 11.5391 0.994922 12.4039 1.37109ZM16.4293 5.00625L4.81719 16.6184C4.09297 16.2105 3.43906 15.7008 2.86602 15.1066L14.9211 3.05508C15.5117 3.62461 16.0215 4.28203 16.4293 5.00625ZM14.573 2.73516L2.54961 14.7586C2.36328 14.5406 2.18398 14.3121 2.01875 14.0766L13.891 2.2043C14.1266 2.36953 14.3551 2.54883 14.573 2.73516ZM17.259 7.06289L6.87383 17.448C6.56094 17.3672 6.25508 17.2687 5.95625 17.1562L16.9672 6.14531C17.0797 6.44414 17.1781 6.75 17.259 7.06289Z",
    fill: "white",
    fillOpacity: 0.313726
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5352 9.19141C17.5352 9.25117 17.5352 9.30742 17.5316 9.36719C17.4402 4.74062 13.6609 1.01758 9.00977 1.01758C4.35859 1.01758 0.579297 4.74062 0.487891 9.36719C0.487891 9.30742 0.484375 9.25117 0.484375 9.19141C0.484375 4.48398 4.30234 0.666016 9.00977 0.666016C13.7172 0.666016 17.5352 4.48398 17.5352 9.19141Z",
    fill: "white",
    fillOpacity: 0.313726
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9395 9.56055C15.9395 13.2484 12.9477 16.2402 9.25977 16.2402C7.18906 16.2402 5.33633 15.2945 4.10938 13.8145C5.3293 15.1328 7.07305 15.959 9.01367 15.959C12.7016 15.959 15.6934 12.9672 15.6934 9.2793C15.6934 7.66211 15.1203 6.18203 14.1641 5.02539C15.2645 6.21719 15.9395 7.80977 15.9395 9.56055Z",
    fill: "white",
    fillOpacity: 0.313726
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01562 15.9629C12.7047 15.9629 15.6953 12.9723 15.6953 9.2832C15.6953 5.59411 12.7047 2.60352 9.01562 2.60352C5.32654 2.60352 2.33594 5.59411 2.33594 9.2832C2.33594 12.9723 5.32654 15.9629 9.01562 15.9629Z",
    fill: "#F39E09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0781 4.92383C12.9074 3.91484 11.3852 3.30664 9.71875 3.30664C6.03086 3.30664 3.03906 6.29844 3.03906 9.98633C3.03906 11.6527 3.64727 13.175 4.65625 14.3457C3.23594 13.1187 2.33594 11.3082 2.33594 9.2832C2.33594 5.59531 5.32773 2.60352 9.01562 2.60352C11.0371 2.60352 12.8512 3.50352 14.0781 4.92383Z",
    fill: "#E88102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5801 5.59141C10.2559 7.11016 6.78242 10.4465 5.08086 14.6828C4.9332 14.5738 4.78906 14.4613 4.64844 14.3383C3.63945 13.1676 3.03125 11.6453 3.03125 9.98242C3.03125 6.29453 6.02305 3.30273 9.71094 3.30273C11.3773 3.30273 12.8996 3.91094 14.0668 4.91992C14.2531 5.13438 14.4219 5.35938 14.5801 5.59141Z",
    fill: "white",
    fillOpacity: 0.145098
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.673828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.3894a86cc77e3a46e6667cf3f12f6549.svg";
export { ForwardRef as ReactComponent };